import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'iv-portfolio-name',
  templateUrl: './portfolio-name.component.html',
  styleUrls: ['./portfolio-name.component.scss']
})
export class PortfolioNameComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Input() initialShowPortfolioName: boolean = false;
  @Input() initialPortfolioName: string = '';
  @Output() portfolioNameChange = new EventEmitter<any>();

  ngOnInit() {
    if (this.parentForm) {
      // Add form controls if they don't exist
      if (!this.parentForm.get('show_portfolio_name')) {
        this.parentForm.addControl('show_portfolio_name', new FormControl(this.initialShowPortfolioName));
      }
      if (!this.parentForm.get('portfolio_name')) {
        this.parentForm.addControl('portfolio_name', new FormControl(this.initialPortfolioName, [Validators.maxLength(255)]));
      }

      // Watch for changes in show_portfolio_name
      this.parentForm.get('show_portfolio_name')?.valueChanges
        .pipe(
          untilDestroyed(this),
          distinctUntilChanged(),
          debounceTime(100)
        )
        .subscribe(value => {
          const portfolioNameControl = this.parentForm.get('portfolio_name');
          
          if (value) {
            portfolioNameControl?.setValidators([Validators.required, Validators.maxLength(255)]);
          } else {
            portfolioNameControl?.setValidators([Validators.maxLength(255)]);
            portfolioNameControl?.setValue('');
          }
          portfolioNameControl?.updateValueAndValidity();
          
          this.portfolioNameChange.emit({ show_portfolio_name: value, portfolio_name: portfolioNameControl?.value });
        });

      // Watch for changes in portfolio_name
      this.parentForm.get('portfolio_name')?.valueChanges
        .pipe(
          untilDestroyed(this),
          distinctUntilChanged(),
          debounceTime(300)
        )
        .subscribe(value => {
          this.portfolioNameChange.emit({ 
            show_portfolio_name: this.parentForm.get('show_portfolio_name')?.value, 
            portfolio_name: value 
          });
        });
    }
  }

  get show_portfolio_name() {
    return this.parentForm?.get('show_portfolio_name')?.value || false;
  }
}
